import { useLocation } from "react-router-dom";
import { getPartnerHeaderConfig } from "../routes/PartnerRoutes/PartnerInfoConfig";

export const usePartnerInfo = () => {
  const location = useLocation();

  // Get the first path segment
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const partnerSlug = pathSegments[0];

  // Check if this is a valid partner using the centralized configuration
  const partnerConfig = getPartnerHeaderConfig(partnerSlug);

  if (!partnerConfig.isValidPartner) {
    return {
      isPartner: false,
      partner: null,
      logo: null,
      displayName: null,
      logoHeaderClassName: null,
    };
  }

  return {
    isPartner: true,
    partner: partnerSlug,
    logo: partnerConfig.logo,
    displayName: partnerConfig.displayName,
    logoHeaderClassName: partnerConfig.logoHeaderClassName,
  };
};
